import { render, staticRenderFns } from "./statementTemplateList.vue?vue&type=template&id=53c9791c"
import script from "./statementTemplateList.vue?vue&type=script&lang=js"
export * from "./statementTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports